module.exports = __webpack_public_path__ + "media/images/icon__settings@3x-10f8ccc08f307d1a4d5b91f51f4c454d.png";